import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ITagIcon, ItemComponent } from '@tecalisdev/infinity';
import { BOOLEAN_STATUS } from '../../../../../processes/models/processes.models';

@Component({
	selector: 'app-item-check-fraud-face',
	imports: [TranslatePipe, ItemComponent],
	templateUrl: './item-check-fraud-face.component.html',
	styleUrl: './item-check-fraud-face.component.scss',
})
export class ItemCheckFraudFaceComponent {
	@Input() status: BOOLEAN_STATUS | string;

	public tagIcon?: ITagIcon;

	ngOnInit(): void {
		this.tagIcon = this.getTagIconItem(this.status);
	}

	public getTagIconItem(status: BOOLEAN_STATUS | string): ITagIcon {
		return status === 'OK'
			? { icon: 'icon-check', status: 'success', size: 'sm' }
			: { icon: 'icon-alert', status: 'error', size: 'sm' };
	}
}
